import fetchTopicTree from './action-topic-list';
import { fetchArticle } from '../../contactUs/actions/action-article';
import { resetRelatedArticle } from '../../contactUs/actions/action-related-article';
import { updateBreadCrumbFromArticleContent } from './action-breadcrumb';
import getCommunityResults from './action-community-posts';
import getOpenDisputes from './action-dispute-transactions';
import Page from '../../lib/page';
import poll from '../../lib/poll';
import { displayChatBot } from './action-chat-bot';
import { trackSetUp } from '../../lib/analytics-helper';
import { isC2MerchantMigrated } from '../../lib/globalHelper';

import {
  isBotExperienceEnabled,
  isElmoTreatmentEnabled,
  isHomeExpTransactionLayoutEnabled,
  isShowOnlySearchLayoutEnabled,
} from '../../../experimentations/helper';
import { trackImpression } from '../../../jsV2/helpers/analytics/fptiHelper';
import { pageNames } from '../../lib/page-name-identifiers';

const validateFptiAndPAYPAL = () => {
  if (typeof window.fpti === 'undefined' || typeof window.PAYPAL === 'undefined') {
    return Promise.reject(false);
  }
  return Promise.resolve(window.fpti);
};

// Innovation Guild: Search only Experiment in Help Center FPTI data
const searchOnlyFPTI = (faqid, articleEcmComponentIds, articleEcmDocId) => {
  let eventNameExp = '';
  if (isShowOnlySearchLayoutEnabled()) {
    eventNameExp = 'search-only-faq-exp';
  } else if (isBotExperienceEnabled()) {
    eventNameExp = 'search-only-bot-acitve-convo-exp';
  }

  const searchOnlyFpti = {
    id: 'articlePage',
    link: `${eventNameExp}|article-opened|${faqid}`,
    hpid: faqid,
    event_name: eventNameExp,
    page: pageNames.articlePage.pageName,
    pgrp: pageNames.articlePage.pageGroupName,
    e: 'im',
    help_component_ids: articleEcmComponentIds,
    help_doc_id: articleEcmDocId,
  };
  trackImpression(searchOnlyFpti);
};

export default function fetchArticleContent(experience, faqid) {
  if ((!isBotExperienceEnabled() && !isHomeExpTransactionLayoutEnabled()) || isElmoTreatmentEnabled()) {
    return (dispatch, getState) => {
      dispatch(resetRelatedArticle());
      const { topicList } = getState();
      if (topicList && topicList.topics && topicList.topics.length <= 0) {
        dispatch(fetchTopicTree(experience));
      }
      dispatch(fetchArticle(faqid, true))
        .then(() => {
          dispatch(displayChatBot());
          const state = getState();
          const response = state.article.article;
          const L3ArticleBreadcrumb = (state.L3TopicList && state.L3TopicList.breadCrumb) || '';
          if (response) {
            poll(validateFptiAndPAYPAL, 5, 100)
              .then(() => {
                // Innovation Guild: Search only Experiment in Help Center
                if (isBotExperienceEnabled() || isShowOnlySearchLayoutEnabled()) {
                  searchOnlyFPTI(faqid, response.ecmComponentIds, response.ecmDocId);
                } else {
                  trackSetUp({
                    id: 'articlePage',
                    link: `smarthelp-article|${faqid}`,
                    hpid: faqid,
                    help_component_ids: response.ecmComponentIds,
                    help_doc_id: response.ecmDocId,
                  });
                }
              })
              .catch(() => {});
            dispatch(updateBreadCrumbFromArticleContent(response, L3ArticleBreadcrumb));
            if (!isC2MerchantMigrated()) {
              dispatch(getCommunityResults({ title: response.articleTitle, id: faqid }));
            }
            // checking articlemapped to condition if same article exists in multiple topics
            const articleMapped = response.articleMappedTo && Page.disputeBreadCrumb(response.articleMappedTo);

            // Validating remote config checks for article id, breadcrumbpath and articlemappedto
            if (
              Page.isLoggedIn() &&
              response &&
              (Page.disputeArticle(response.articleId) ||
                articleMapped ||
                Page.disputeBreadCrumb(response.breadCrumbPath))
            ) {
              dispatch(getOpenDisputes());
            }
          } else {
            poll(validateFptiAndPAYPAL, 5, 100)
              .then(() => trackSetUp({ id: 'articleErrorPage', link: `smarthelp-error-article|${faqid}`, hpid: faqid }))
              .catch(() => {});
          }
        })
        .catch(() => {});
    };
  }
  return () => {};
}
